import {
  Component,
  OnInit,
  ViewChild,
  Inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { ApiDataSource } from 'src/app/utils/api-data-source';
import { tap } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AppService } from 'src/app/app.service';
import { ApiRequestService } from '../api-request.service';

@Component({
  selector: 'app-slave-accounts-selector',
  templateUrl: './slave-accounts-selector.component.html',
  styleUrls: ['./slave-accounts-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SlaveAccountsSelectorComponent implements OnInit {
  // Columns to show in the view
  displayedColumns: string[] = ['id', 'name'];

  // The data source
  dataSource: SlaveAccountsSelectorDataSource;

  // The paginator and sorter objects
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public app: AppService,
    public api: ApiRequestService,
    public dialogRef: MatDialogRef<SlaveAccountsSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Set multiple if it is not present and default it to false
    if (
      typeof this.data['multiple'] === 'undefined' ||
      typeof this.data['multiple'] !== 'boolean'
    ) {
      this.data['multiple'] = false;
    }

    if (this.data['multiple']) {
      this.displayedColumns.unshift('select');
    } else {
      this.displayedColumns.push('actions');
    }

    // Construct the datasource
    this.dataSource = new SlaveAccountsSelectorDataSource(
      this.app,
      this.api,
      this.data['multiple']
    );

    // Set a default selection if no selected values are passed through
    if (typeof this.data['selected'] === 'undefined') {
      this.data['selected'] = [];
    }

    // Loop and select the values in the data source
    for (let i = 0; i < this.data['selected'].length; i++) {
      this.dataSource.selection.select(this.data['selected'][i]);
    }

    // Get the data
    this.dataSource.getData();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    // Reset the paginator when sorting
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    const _tap = tap(() => {
      this.dataSource.limit = this.paginator.pageSize;
      this.dataSource.offset = this.paginator.pageIndex;
      this.dataSource.order_by = this.sort.active;
      this.dataSource.order = this.sort.direction;

      this.dataSource.getData();
    });

    // Subscribe to the paginator tap events
    this.paginator.page.pipe(_tap).subscribe();
    this.sort.sortChange.pipe(_tap).subscribe();
  }

  onSelectSingle(id: number) {
    this.dialogRef.close(id);
  }

  onSelectMultiple() {
    this.dialogRef.close(this.dataSource.selection.selected);
  }

  onSelectAllRecords() {
    this.dialogRef.close(this.dataSource.ids);
  }

  onDeselectAllRecords() {
    this.dataSource.selection.clear();
  }

  /**
   * Close the dialog.
   */
  onClose(): void {
    this.dialogRef.close();
  }
}

export class SlaveAccountsSelectorDataSource extends ApiDataSource {
  order_by = 'id';
  order = 'asc';

  getData(resetOffset: boolean = false) {
    this.makeRequest(
      'v2/related-accounts/selectable-slave-accounts',
      resetOffset
    );
  }
}
